export const PWA_KEYS = {
  firstSave: 'tts_pwa_first_save',
  offered: 'tts_pwa_install_offered',
  dismissed: 'tts_pwa_install_dismissed',
  installed: 'tts_pwa_installed',
};

// Installation preferences are local UI preferences, not another data store.
// Storage restrictions must never turn a successful Quick Save into a failure.
export function readInstallFlag(key) {
  try { return localStorage.getItem(key) === '1'; } catch { return false; }
}
export function writeInstallFlag(key) {
  try { localStorage.setItem(key, '1'); } catch { /* Keep working in this tab. */ }
}
export function isStandalone() {
  return navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: window-controls-overlay)').matches;
}
export function installPlatform() {
  const ua = navigator.userAgent;
  const inAppBrowser = /FBAN|FBAV|FB_IAB|FBIOS|FB4A|FBSS/i.test(ua) ? 'Facebook' : /Instagram/i.test(ua) ? 'Instagram' : /Messenger/i.test(ua) ? 'Messenger' : null;
  const ios = /iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (ios) return { name: 'ios', safari: !inAppBrowser && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua), inAppBrowser };
  if (/Android/i.test(ua)) return { name: 'android', inAppBrowser };
  if (/Safari/i.test(ua) && !/Chrome|Chromium|Edg/i.test(ua)) return { name: 'mac-safari' };
  return { name: 'desktop' };
}

export function safePhoneLink(location = window.location) {
  const url = new URL('/', location.origin);
  const incoming = new URLSearchParams(location.search);
  for (const key of ['source', 'utm_source', 'utm_medium', 'utm_campaign']) {
    const value = incoming.get(key);
    if (value && /^[a-z0-9_-]{1,80}$/i.test(value)) url.searchParams.set(key, value);
  }
  return url.href;
}